import { useCallback } from "react"
import _ from "lodash"

import { filterSuggestedSearchResult } from "../utils/search"
import { useFeatureSearch } from "hooks/feature/useSearchFeatures/useFeatureSearch"

type GetSuggestedSearchItems = (venueFilter: string) => Array<object>

export const useSearch = (imdfData, { config, enable }) => {
  const { fuse, search } = useFeatureSearch({
    config,
    collections: imdfData,
    enabled: enable,
  })

  /** Initial suggested Search List
   * First 50 occupants
   * order by: is_featured = true
   * then name.en
   */
  const getSuggestedSearchItems: GetSuggestedSearchItems = useCallback(
    (venueFilter = "") => {
      return _(imdfData)
        .filter(filterSuggestedSearchResult)
        .filter(
          (result) =>
            !venueFilter || result.properties?.venue_id === venueFilter
        )
        .orderBy(
          ["properties.is_featured", "properties.name.en"],
          ["desc", "asc"]
        )
        .take(50)
        .value()
    },
    [imdfData]
  )

  return {
    fuse,
    search,
    getSuggestedSearchItems,
  }
}
